"use client";
import React, { useEffect } from "react";
import { InteractionStatus } from "@azure/msal-browser";
import { getJWT, isJwtExpired } from "@/lib/auth";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useRouter, usePathname } from "next/navigation";
import Image from "next/image";
import logo from "@/app/images/f_logo.svg";

const Home = () => {
    const isAuthenticated = useIsAuthenticated();
    const { inProgress, instance, accounts } = useMsal();
    const router = useRouter();
    const pathname = usePathname();

    useEffect(() => {
        console.log("[Root Page] pathname:", pathname, "isAuthenticated:", isAuthenticated, "inProgress:", inProgress);

        // Only run if we're actually on the root page
        if (pathname !== "/") {
            console.log("[Root Page] Not on root page, skipping redirect logic");
            return;
        }

        if (inProgress === InteractionStatus.None) {
            if (!isAuthenticated) {
                console.log("[Root Page] Not authenticated, redirecting to /signin/");
                router.push("/signin/");
            } else if (isAuthenticated && accounts.length > 0) {
                console.log("[Root Page] Authenticated, checking JWT and redirecting to /fai/");
                getJWT(instance, accounts)
                    .then((jwt) => {
                        const expired = isJwtExpired(jwt);
                        if (expired) {
                            console.log("[Root Page] JWT expired, redirecting to /signin/");
                            router.push("/signin/");
                        } else {
                            console.log("[Root Page] JWT valid, redirecting to /fai/");
                            router.push("/fai/");
                        }
                    })
                    .catch((error) => {
                        console.error("[Root Page] Error getting JWT:", error);
                        router.push("/signin/");
                    });
            }
        }
    }, [accounts, inProgress, instance, isAuthenticated, router, pathname]);

    return (
        <>
            <div className={`grid grid-cols-1 h-[90vh] justify-items-center items-center animate-slowfade`}>
                <div className={"animate-growshrink"}>
                    <Image src={logo} alt={"Fender F"} width={48} height={50} />
                </div>
            </div>
        </>
    );
};

export default Home;
